import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "../../Shared/Button";

import ContactFooter from "../../ContactFooter";
import ProjectTeamCard from "../ProjectTeamCard";
import FishPopup from "../../FishPopup";
import useScrollTo from "../../../hooks/useScrollTo";

import { getUserDetails } from "../../../firebase-config";
import "./projectDetails.css";
import { useDispatch, useSelector } from "react-redux";
import { getProjectByName } from "../../../Datahandler";
import ModalPopup from "../../ModalPopup";
import { setInProgressProject } from "../../ModalPopup/CreateProjectModal/redux/actions";
import Members from "../../Shared/Members";
import { addToast } from "../../Shared/Toasts/redux/actions";

const ProjectDetails = () => {
  const params = useParams();
  const title = params.title;

  const currentUser = useSelector((state) => state.user.loggedInUser);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [project, setProject] = useState(null);
  useScrollTo();

  const handleClose = () => setShowModal(false);

  useEffect(() => {
    getProjectByName(title)
      .then((res) => {
        setProject(res);
      })
      .catch((e) => {
        dispatch(
          addToast({
            header: "Failure",
            body: `Project failed to load successfully updated`,
            time: Date.now(),
            status: "failure",
            id: crypto.randomUUID(),
          })
        );
      });
  }, [title, dispatch]);

  const handleButtonClick = () => {
    setShowModal(true);
  };
  const handleGithubButtonClick = () => {
    window.open(project?.gitUrl, "_blank");
  };
  const handleTasklistButtonClick = () => {
    setShowModal(true);
  };

  const handleEditProject = async () => {
    dispatch(setInProgressProject(project));
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return project ? (
    <>
      <div className="introContainer">
        <Container fluid>
          <Row>
            <Col xs={12} md={7} style={{ float: "left" }}>
              <h1 className="introTitle">{project?.title}</h1>
            </Col>
          </Row>
          <Row id="project-details-description-container">
            <Col xs={12} md={10} style={{ float: "left" }}>
              <span
                dangerouslySetInnerHTML={{ __html: project?.description }}
              />
            </Col>
          </Row>
          <Row id="project-details-video-container">
            <Col xs={12} md={{ span: 10, offset: 1 }} style={{ float: "left" }}>
              <div className="video-frame">
                <video
                  src={project?.videoUrl}
                  controls
                  muted
                  className="video-element"
                />
              </div>
            </Col>
          </Row>
          <Row id="project-details-buttons-container">
            <Col xs={12} md={{ span: 10, offset: 1 }}>
              <div className="buttonContainer">
                <Button
                  text="Request to join the project"
                  buttonStyle="pink"
                  onClick={handleButtonClick}
                />
                {(currentUser?.level >= 100 ||
                  project?.members.includes(currentUser?.uid)) && (
                  <Button
                    text="Open on GitHub"
                    buttonStyle="pink-transparent"
                    onClick={handleGithubButtonClick}
                  />
                )}
                {(currentUser?.level >= 1000 ||
                  project?.contactUid === currentUser?.uid) && (
                  <Button
                    text="Edit Project"
                    buttonStyle="pink"
                    onClick={handleEditProject}
                  />
                )}
              </div>
            </Col>
          </Row>
          <br />
          <br />
          <br />

          <Row id="project-details-team-container">
            <Col xs={12} md={{ span: 10, offset: 1 }}>
              <h2 className="teamTitle">Contributors</h2>
            </Col>
          </Row>

          <Row className="cards">
            <Members memberIds={project?.members} />
          </Row>
        </Container>
        {showModal && (
          <ModalPopup
            show={handleEditProject}
            handleClose={handleCloseModal}
            description={"Fill in the form to edit the project."}
            title={"Edit a project!"}
            image={null}
            type={"createProject"}
          />
        )}
      </div>

      <ContactFooter />
    </>
  ) : (
    <p> Loading</p>
  );
};

export default ProjectDetails;
